import { generatePath } from 'react-router-dom'
import { CompanyTag } from '@/components/ui/badge'
import { GridCellProps, GridColumnProps } from '@progress/kendo-react-grid'
import { LeadSearchResultDto } from 'api/Search/Types/SearchResultDto'
import { Link } from 'components/Link'
import { links } from 'utils/featureToggles'

export const LeadColumnDefinition: GridColumnProps[] = [
  {
    title: 'Name',
    cell: (props: GridCellProps): JSX.Element => {
      const data = props.dataItem as LeadSearchResultDto
      if (!data.value) {
        return <td />
      }
      if (!data.id) {
        return <td />
      }
      return (
        <td style={{ color: 'var(--link)', textDecoration: 'underline' }}>
          <Link
            to={{
              pathname: generatePath(links.recordsLeads.detailsUrl as string, {
                id: data.id,
                slug: 'details',
              }),
            }}
          >
            {data.value}
          </Link>
        </td>
      )
    },
  },
  {
    title: 'Email',
    field: 'data.email',
  },
  {
    title: 'Country',
    field: 'data.country.name',
  },
  {
    title: 'Entity',
    cell: (props: GridCellProps): JSX.Element => {
      const data = props.dataItem as LeadSearchResultDto
      if (!data.data?.tickmillCompany?.id) {
        return <td />
      }
      return (
        <td className='table-columns__content'>
          <CompanyTag id={data.data.tickmillCompany.id}>
            {data.data.tickmillCompany.name}
          </CompanyTag>
        </td>
      )
    },
    width: 80,
    minResizableWidth: 80,
  },
]
